
import {
  Vue, Component,
} from 'vue-property-decorator';
import moment from 'moment';
import { LogEvent } from '@/types';

moment.locale('it');

@Component
export default class LeadLogs extends Vue {
  unorderedEvents: LogEvent[] = []

  created() {
    // eslint-disable-next-line no-console
    console.log('LeadLogs: created()');

    this.refreshEvents();
  }

  get lead() {
    return this.$store.getters.currentLead;
  }

  get events(): LogEvent[] {
    return this.unorderedEvents
      .sort((a: LogEvent, b: LogEvent) => a.date.valueOf() - b.date.valueOf());
  }

  mDateTime(date: Date) {
    return `${moment(date).format('L')} ore ${moment(date).format('LT')}`;
  }

  refreshEvents() {
    // eslint-disable-next-line no-console
    console.log('LeadLogs: refreshEvents()');

    if (this.lead.newDate) {
      this.unorderedEvents.push({
        title: 'Assegnata',
        color: 'statusNew',
        date: this.lead.newDate,
      });
    }

    if (this.lead.cancelledDate) {
      this.unorderedEvents.push({
        title: 'Annullata',
        color: 'statusCancelled',
        date: this.lead.cancelledDate,
      });
    }

    if (this.lead.rejectedDate) {
      this.unorderedEvents.push({
        title: 'Respinta',
        color: 'statusRejected',
        date: this.lead.rejectedDate,
      });
    }

    if (this.lead.openDate) {
      this.unorderedEvents.push({
        title: 'Presa in carico',
        color: 'statusOpen',
        date: this.lead.openDate,
      });
    }

    if (this.lead.closedDate) {
      this.unorderedEvents.push({
        title: 'Chiusa',
        color: 'statusClosed',
        date: this.lead.closedDate,
      });
    }

    if (this.lead.resolvedDate) {
      this.unorderedEvents.push({
        title: 'Completata',
        color: 'statusResolved',
        date: this.lead.resolvedDate,
      });
    }
  }
}
